document.addEventListener('click', function (e) {
  const tabBtn = e.target.closest('.tab-btn');
  if (tabBtn) {
    e.preventDefault();
    const wrapper = tabBtn.closest('.madeo-tabs');
    if (!wrapper) return;

    const tabId = tabBtn.getAttribute('data-tab');
    if (!tabId) return;

    wrapper.querySelectorAll('.tab-btn').forEach((b) => b.classList.remove('active'));
    tabBtn.classList.add('active');

    wrapper.querySelectorAll('.madeo-tab-content').forEach((panel) => {
      panel.classList.remove('active');
    });

    const target = wrapper.querySelector('#' + CSS.escape(tabId));
    if (target) target.classList.add('active');
    return;
  }

  const subtabBtn = e.target.closest('.subtab-btn');
  if (subtabBtn) {
    e.preventDefault();
    const wrapper = subtabBtn.closest('.madeo-subtabs');
    if (!wrapper) return;

    const subtabId = subtabBtn.getAttribute('data-subtab');
    if (!subtabId) return;

    wrapper.querySelectorAll('.subtab-btn').forEach((b) => b.classList.remove('active'));
    subtabBtn.classList.add('active');

    wrapper.querySelectorAll('.madeo-subtab-content').forEach((panel) => {
      panel.classList.remove('active');
    });

    const target = wrapper.querySelector('#' + CSS.escape(subtabId));
    if (target) target.classList.add('active');
  }
});